import {
  CommonService,
  Exception,
  StorageService,
  StorageType,
  ToasterService,
} from '@anddone/ui-utilities';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginService } from '../../../services/login-service';

@Component({
  selector: 'app-side-nav',
  imports: [TranslatePipe, RouterLink, RouterLinkActive, NgbDropdownModule],
  templateUrl: './side-nav.html',
  styleUrl: './side-nav.scss',
})
export class SideNav implements OnInit {
  loggedInUserData: any = {};
  loginData: any = {};
  allyName = '';
  userName = '';
  userId: any;
  shortName = '';
  isBoolean = false;
  activeLink = '';
  prevBtn: any;
  nonDefaultAdminLoggedInUserData: any = {};
  merchantId: any;
  public toasterService = inject(ToasterService);

  private router = inject(Router);
  private storageService = inject(StorageService);
  private commonService = inject(CommonService);
  private loginService = inject(LoginService);

  constructor() {
    const data = this.storageService.get(StorageType.Session, 'auth');
    this.loginData = data ? JSON.parse(data) : null;
  }

  ngOnInit(): void {
    let data = this.storageService.get(StorageType.Session, 'nonDefaultAdminUser');
    this.nonDefaultAdminLoggedInUserData = data ? JSON.parse(data) : null;

    data = this.storageService.get(StorageType.Session, 'userDetails');
    this.loggedInUserData = data ? JSON.parse(data) : null;

    this.allyName = this.loggedInUserData?.name;

    if (this.loginData?.userId?.length > 0) {
      this.userId = this.loginData?.userId;
      this.userName = `${this.nonDefaultAdminLoggedInUserData?.contact?.name?.firstName} ${this.nonDefaultAdminLoggedInUserData?.contact?.name?.lastName}`;
      this.shortName = `${this.nonDefaultAdminLoggedInUserData?.contact?.name?.firstName?.charAt(
        0
      )}${this.nonDefaultAdminLoggedInUserData?.contact?.name?.lastName?.charAt(0)}`;
    } else {
      this.userName = `${this.loggedInUserData?.contact?.name?.firstName} ${this.loggedInUserData?.contact?.name?.lastName}`;
      this.shortName = `${this.loggedInUserData?.contact?.name?.firstName?.charAt(
        0
      )}${this.loggedInUserData?.contact?.name?.lastName?.charAt(0)}`;
    }
  }

  profileSelection(link: any) {
    this.router.navigate([link]);
  }

  logOut() {
    this.loginService.logout().subscribe({
      next: () => {
        this.commonService.logOut();
      },
      error: (error: any) => {
        const toastMessage = Exception.exceptionMessage(error);
        this.toasterService.showError(toastMessage.join(', '), 'full');
      },
    });
  }

  linkToProfile() {
    this.router.navigate(['/ally/user-profile/' + this.userId]);
  }
}
